<div class="iframe-wrapper">
    <iframe *ngIf="url"
            [src]="url | safeUrl"
            frameborder="0"
            style="width: 100%; height: calc(100vh - 280px);">
    </iframe>
</div>

<div class="footer w-full flex align-items-center py-3 px-4 bg-gray-50 fixed bottom-0 left-0"
     *ngIf="!isOpenedManually">
    <input id="dontShowCheckBox"
           type="checkbox"
           class="w-2rem h-2rem mr-2"
           [(ngModel)]="isDontShowSelected">
    <label for="dontShowCheckBox" class="text-xl">
        Don't show this to me again
    </label>
</div>
